import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=d577d6a4&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=d577d6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d577d6a4",
  null
  
)

export default component.exports